import Vue from "vue";
import { checkResponse } from "@/helpers/store";
import {
  regionName,
  streetWithTypeName,
  closeReasonName,
  habitName,
  propertyName
} from "@/helpers/reference";

const state = {
  subscribers: {
    data: [],
    rows: 0
  }
};

const mutations = {
  setSubscribers: (state, payload) => (state.subscribers = payload),
  clearSubscribers: state => (state.subscribers = { data: [], rows: 0 })
};

const actions = {
  async getSubscribers(
    { commit, rootState },
    {
      abcode,
      abcodeTypeSearch,
      fio,
      fioTypeSearch,
      region,
      street,
      nHouse,
      charHouse,
      corpHouse,
      nFlat,
      charFlat,
      ncount,
      ncountTypeSearch,
      docnumber,
      docnumberTypeSearch,
      eic,
      eicTypeSearch,
      dateBegin,
      dateEnd,
      nact,
      nactTypeSearch,
      accountNumber,
      fiofiz,
      fiofizTypeSearch,
      phone,
      phoneTypeSearch,
      numberhouses,
      numberhousesTypeSearch
    }
  ) {
    try {
      commit("setFullPageLoading", true);

      let params = {
        script: "web.wbabon",
        funcname: "wbRunSelect"
      };

      if (abcode) {
        switch (abcodeTypeSearch) {
          case "0": // совпадение
            params["abcode"] = `${abcode}`;
            break;
          case "1": // вхождение
            params["abcodelike"] = `${abcode}`;
            break;
          case "2": // начинается на
            params["abcodelikebegin"] = `${abcode}`;
            break;
          case "3": // заканчивается на
            params["abcodelikeend"] = `${abcode}`;
            break;
        }
      }

      if (fio) {
        switch (fioTypeSearch) {
          case "0": // совпадение
            params["fio"] = `${fio}`;
            break;
          case "1": // вхождение
            params["fiolike"] = `${fio}`;
            break;
          case "2": // начинается на
            params["fiolikebegin"] = `${fio}`;
            break;
          case "3": // заканчивается на
            params["fiolikeend"] = `${fio}`;
            break;
        }
      }

      if (region) params["coder"] = `${region}`;
      if (street) params["codestreet"] = `${street}`;

      if (nHouse > 0) params["nhouse"] = `${nHouse}`;
      if (charHouse) params["charhouse"] = `${charHouse}`;

      if (corpHouse) params["korpus"] = `${corpHouse}`;

      if (nFlat > 0) params["nflat"] = `${nFlat}`;
      if (charFlat) params["charflat"] = `${charFlat}`;

      if (ncount) {
        switch (ncountTypeSearch) {
          case "0": // совпадение
            params["pncount"] = `${ncount}`;
            break;
          case "1": // вхождение
            params["pncountlike"] = `${ncount}`;
            break;
          case "2": // начинается на
            params["pncountlikebegin"] = `${ncount}`;
            break;
          case "3": // заканчивается на
            params["pncountlikeend"] = `${ncount}`;
            break;
        }
      }

      if (docnumber) {
        switch (docnumberTypeSearch) {
          case "0": // совпадение
            params["docnumber"] = `${docnumber}`;
            break;
          case "1": // вхождение
            params["docnumberlike"] = `${docnumber}`;
            break;
          case "2": // начинается на
            params["docnumberlikebegin"] = `${docnumber}`;
            break;
          case "3": // заканчивается на
            params["docnumberlikeend"] = `${docnumber}`;
            break;
        }
      }

      if (eic) {
        switch (eicTypeSearch) {
          case "0": // совпадение
            params["peic"] = `${eic}`;
            break;
          case "1": // вхождение
            params["peiclike"] = `${eic}`;
            break;
          case "2": // начинается на
            params["peiclikebegin"] = `${eic}`;
            break;
          case "3": // заканчивается на
            params["peiclikeend"] = `${eic}`;
            break;
        }
      }

      if (dateBegin) params["pdatecreate"] = `${dateBegin}`;
      if (dateEnd) params["pdateclose"] = `${dateEnd}`;

      if (nact) {
        switch (nactTypeSearch) {
          case "0": // совпадение
            params["pnumberact"] = `${nact}`;
            break;
          case "1": // вхождение
            params["pnumberactlike"] = `${nact}`;
            break;
          case "2": // начинается на
            params["pnumberactlikebegin"] = `${nact}`;
            break;
          case "3": // заканчивается на
            params["pnumberactlikeend"] = `${nact}`;
            break;
        }
      }

      if (accountNumber > 0) params["pnumberaccount"] = `${accountNumber}`;

      if (fiofiz) {
        switch (fiofizTypeSearch) {
          case "0": // совпадение
            params["fiofiz"] = `${fiofiz}`;
            break;
          case "1": // вхождение
            params["fiofizlike"] = `${fiofiz}`;
            break;
          case "2": // начинается на
            params["fiofizlikebegin"] = `${fiofiz}`;
            break;
          case "3": // заканчивается на
            params["fiofizlikeend"] = `${fiofiz}`;
            break;
        }
      }

      if (phone) {
        switch (phoneTypeSearch) {
          case "0": // совпадение
            params["phone"] = `${phone}`;
            break;
          case "1": // вхождение
            params["phonelike"] = `${phone}`;
            break;
          case "2": // начинается на
            params["phonelikebegin"] = `${phone}`;
            break;
          case "3": // заканчивается на
            params["phonelikeend"] = `${phone}`;
            break;
        }
      }

      if (numberhouses) {
        switch (numberhousesTypeSearch) {
          case "0": // совпадение
            params["pnumberhouses"] = `${numberhouses}`;
            break;
          case "1": // вхождение
            params["pnumberhouseslike"] = `${numberhouses}`;
            break;
          case "2": // начинается на
            params["pnumberhouseslikebegin"] = `${numberhouses}`;
            break;
          case "3": // заканчивается на
            params["pnumberhouseslikeend"] = `${numberhouses}`;
            break;
        }
      }

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setSubscribers", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  subscribers: (state, rootState) => {
    let items = [];
    state.subscribers.data.forEach(item => {
      item["regionname"] = regionName(
        rootState.params.gregion.data,
        item.coder
      );
      item["streetname"] = streetWithTypeName(
        rootState.params.street.data,
        item.codestreet
      );
      item["closereasonname"] = closeReasonName(
        rootState.params.gclientclosereason.data,
        item.codeclosereason
      );
      item["habitname"] = habitName(
        rootState.params.ghabit.data,
        item.codehabit
      );
      item["propertyname"] = propertyName(
        rootState.params.gproperty.data,
        item.typesob
      );
      items.push(item);
    });

    return items;
  }
};

export default { state, mutations, actions, getters };
